import useCurrentResourceCentre from "./useCurrentResourceCentre";

const useModuleSubscriptions = (): {
  isPayrollSubscribed: boolean;
  isAttendanceSubscribed: boolean;
  isDaybookSubscribed: boolean;
  isStockSubscribed: boolean;
  isIpdSubscribed: boolean;
  isOpdSubscribed: boolean;
  isLabSubscribed: boolean;
  isMedicalSubscribed: boolean;
  isHmisSubscribed: boolean;
  isClientSubscribed: boolean;
  isBookingSubscribed: boolean;
  isBillSubscribed: boolean;
} => {
  const rc = useCurrentResourceCentre();

  const subscription = rc?.subscription || {};
  const isPayrollSubscribed = subscription.features?.payroll?.subscribed ?? false;
  const isAttendanceSubscribed = subscription.features?.attendance?.subscribed ?? false;
  const isDaybookSubscribed = subscription.features?.daybook?.subscribed ?? false;
  const isStockSubscribed = subscription.features?.stock?.subscribed ?? false;
  const isIpdSubscribed = subscription.features?.ipd?.subscribed ?? false;
  const isOpdSubscribed = subscription.features?.opd?.subscribed ?? false;
  const isLabSubscribed = subscription.features?.lab?.subscribed ?? false;
  const isMedicalSubscribed = subscription.features?.medical?.subscribed ?? false;
  const isHmisSubscribed = subscription.features?.hmis?.subscribed ?? false;
  const isClientSubscribed = subscription.features?.clients?.subscribed ?? false;
  const isBookingSubscribed = subscription.features?.booking?.subscribed ?? false;
  const isBillSubscribed = subscription.features?.bill?.subscribed ?? false;

  return {
    isPayrollSubscribed,
    isAttendanceSubscribed,
    isDaybookSubscribed,
    isStockSubscribed,
    isIpdSubscribed,
    isOpdSubscribed,
    isLabSubscribed,
    isMedicalSubscribed,
    isHmisSubscribed,
    isClientSubscribed,
    isBookingSubscribed,
    isBillSubscribed
  };
};

export default useModuleSubscriptions;
